import React from 'react'

const ValidationErrorText = ({ text, extraClass }) => {
    return <span className={`text-danger text-sm mb-0 mt-1 ${extraClass}`}>{text}</span>;
  };

export default ValidationErrorText
